import Shop from '@/shop';
import _Singleton, { deferredSingletonExport } from '@/tools/singleton';
import CartTasks from '@/cart-task-manager';

import CartOrder from './cart.order';

/*
 * @class
 * Cart
 */
var Cart = function() {
  var self = this;

  self.order = new CartOrder(self);

  self.tasks = new CartTasks(self);

  // фикс призрачной ошибки в ios "kCFErrorDomainCFNetwork error 303"
  setTimeout(() => {
    if (document.readyState == 'complete' && !self.order._inited && !Shop.config.config.is_minisite) {
      self.forceUpdate();
    }
  }, 3000);
};

/**
 * Добавить в корзину заданное кол-во товаров
 * @method
 *
 * @param {Object} task - задача
 * @param {Object} task.items - { variant_id: quantity, ... }
 * @param {Object} task.comments - { variant_id: comment, ...}
 * @param {string} task.coupon - название купона
 *
 * @fires before:insales:cart
 * @fires add_items:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.add = function(task) {
  var self = this;

  task = task || {};
  task.method = 'add_items';

  self.tasks.send(task);
};

/**
 * Удадить из корзины заданное кол-во товаров
 * @method
 *
 * @param {Object} task - задача
 * @param {Object} task.items - { variant_id: quantity, ... }
 * @param {Object} task.comments - { variant_id: comment, ...}
 * @param {string} task.coupon - название купона
 *
 * @fires before:insales:cart
 * @fires remove_items:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.remove = function(task) {
  var self = this;

  task = task || {};
  task.method = 'remove_items';

  self.tasks.send(task);
};

/**
 * Устанавливает кол-во товаров в корзине для каждой позиции
 * @method
 *
 * @param {Object} task - задача
 * @param {Object} task.items - { variant_id: quantity, ... }
 * @param {Object} task.comments - { variant_id: comment, ...}
 * @param {string} task.coupon - название купона
 *
 * @fires before:insales:cart
 * @fires set_items:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.set = function(task) {
  var self = this;

  task = task || {};
  task.method = 'set_items';

  self.tasks.send(task);
};

/**
 * Удалить позиции из корзины
 * @method
 *
 * @param {Object} task - задача
 * @param {Array} task.items - [variant_id, ...]
 *
 * @fires before:insales:cart
 * @fires delete_items:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.delete = function(task) {
  var self = this;

  task = task || {};
  task.method = 'delete_items';

  self.tasks.send(task);
};

/**
 * Полностью очистить корзину
 * @method
 *
 * @fires before:insales:cart
 * @fires clear_items:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.clear = function(task) {
  var self = this;

  task = task || {};
  task.method = 'clear_items';

  self.tasks.send(task);
};

/**
 * Полностью обновить корзину
 * @method
 *
 * @fires before:insales:cart
 * @fires clear_items:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.forceUpdate = function() {
  var self = this;

  var task = {};
  task.method = 'force_update';

  self.tasks._update({}, task);
};

/**
 * Добавление товаров в корзину для "Заказа в один клик"
 * @method
 * @private
 *
 * @param {}
 *
 * @fires before:insales:cart
 * @fires add_checkout:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.add_checkout = function(task) {
  var self = this;

  task = task || {};
  task.method = 'add_checkout';

  self.tasks.send(task);
};

/**
 * Устанавливаем купон
 * @method
 *
 * @param {Object} task - задача
 * @param {string} task.coupon - название купона
 *
 * @fires before:insales:cart
 * @fires set_coupon:insales:cart
 * @fires update_items:insales:cart
 * @fires always:insales:cart
 */
Cart.prototype.setCoupon = function(task) {
  var self = this;

  task = task || {};
  task.method = 'set_coupon';

  self.tasks.send(task);
};

/**
 * Получить состав корзины
 * @method
 * @deprecated c 0.6.0. Использовать Cart.order.get();
 * @private
 */
Cart.prototype.getOrder = function() {
  var self = this;

  return self.order.get();
};

/**
 * Установка настроек для корзины
 * @method
 * @private
 */
Cart.prototype.setConfig = function(settings) {
  var self = this;

  return;
};

/**
 * Заглушка для "Купить в один клик" из бандла
 * @method
 * @private
 */
Cart.prototype.addItem = function() {
  return;
};

export default deferredSingletonExport(_Singleton(Cart), Cart);
